import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useBreadcrumbContext } from '../../../contexts/BreadcrumbContext';
import { surveyApi } from '../api/surveyApi';
import { surveyQueryKeys } from './queryKeys';

/**
 * Sets breadcrumb metadata with the survey title for the given survey ID.
 * Used in survey detail pages (SurveyBuilder) to resolve the UUID breadcrumb.
 */
export const useSurveyBreadcrumb = (surveyId: string | undefined) => {
  const { setMetadata } = useBreadcrumbContext();

  const { data } = useQuery({
    queryKey: surveyQueryKeys.survey(surveyId!),
    queryFn: () => surveyApi.getSurvey(surveyId!),
    enabled: !!surveyId,
  });

  useEffect(() => {
    if (data?.data?.title) {
      setMetadata({ surveyTitle: data.data.title });
    }
  }, [data?.data?.title, setMetadata]);

  useEffect(() => {
    return () => {
      setMetadata({ surveyTitle: undefined });
    };
  }, [surveyId, setMetadata]);
};
